import React, { useEffect, useState } from "react";
import axios from "axios";
import "../style/more.css";

function MoreInfo({ match }) {
  var Key = "AIzaSyB6q_3L3bVEjzVC_zFfJfaQf4iaThYo2CI";
  var count = 1;
  useEffect(() => {
    simpleton();
    youtubeGetData();
  }, []);

  const [item, setItems] = useState([]);
  const [avail, isAvail] = useState(false);
  const [sequel, setSequel] = useState([]);
  const [youtubeGot, setYoutube] = useState([]);

  const simpleton = async () => {
    axios
      .get(`https://api.jikan.moe/v3/anime/${match.params.id}`)
      .then((res) => {
        const data = res.data;
        setItems(data);
        setSequel(data.related.Sequel);
        isAvail(true);
      });
  };
  const sequelInfo = async () => {
    axios
      .get(`https://api.jikan.moe/v3/anime/${sequel.mal_id}`)
      .then((resp) => {
        const sequelity = resp.data;
      });
  };
  const youtubeGetData = () => {
    axios
      .get(
        `https://www.googleapis.com/youtube/v3/search?part=snippet&maxResults=${count}&q=${
          item.title + "trailer"
        }
        &type=video&key=${Key}`
      )
      .then((res) => {
        const newdata = res.data.items;
        setYoutube(newdata);
      });
  };

  if (avail) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-12">
            <span>
              <img src={item.image_url} alt={item.title} />
              <span>
                <p className="detail-words">Rank: {item.rank}</p>
                <p className="detail-words">Rating: {item.rating}</p>
                <p className="detail-words">Airing: {item.aired.string}</p>
                <p className="detail-words">Status: {item.status}</p>
              </span>
            </span>
          </div>
          <div className="col-lg-8 col-md-8 col-sm-12">
            <div className="col">
              <p className="title-effect">{item.title}</p>
              <p className="detail-words">
                Other names: {item.title_english}, {item.title_japanese}
              </p>
              <p className="detail-words">Rating: {item.score}</p>
              <p className="title-effect">Description</p>
              <p className="detail-words">{item.synopsis}</p>
            </div>
          </div>
          <div className="col-lg-12 col-md-12 col-sm-12 some-margin">
            <p className="title-effect">{item.title} trailer</p>
            {item.trailer_url == null ? (
              youtubeGot.map((i) => (
                <iframe
                  key={i.etag}
                  src={"https://www.youtube.com/embed/" + i.id.videoId}
                  frameBorder="0"
                ></iframe>
              ))
            ) : (
              <iframe
                src={item.trailer_url}
                title={item.title_english}
                frameBorder="0"
                width="500"
                height="500"
              ></iframe>
            )}
          </div>
          <div className="col-lg-12 col-md-12 col-sm-12 some-margin">
            <p className="title-effect">Where to Watch</p>
            <p className="detail-words">
              Site - 4anime:{" "}
              <a
                className="fouranime"
                href={`https://4anime.to/anime/${item.title
                  .replace(/[^a-zA-Z ]/g, "")
                  .replace(/\s+/g, "-")}`}
                target="_blank"
              >
                {item.title.replace(/\s+/g, "-")}
              </a>
            </p>
            <p className="detail-words">
              Site - GoGoanime:{" "}
              <a
                className="gogo"
                href={`https://gogoanime.so/category/${item.title
                  .replace(/[^a-zA-Z ]/g, "")
                  .replace(/\s+/g, "-")}`}
                target="_blank"
              >
                {item.title.replace(/\s+/g, "-")}
              </a>
            </p>
            <p className="detail-words">
              Site - Anime-Twist:{" "}
              <a
                className="twist"
                href={`https://twist.moe/a/${item.title
                  .replace(/[^a-zA-Z ]/g, "")
                  .replace(/\s+/g, "-")}/1`}
                target="_blank"
              >
                {item.title}
              </a>
            </p>
          </div>
        </div>
      </div>
    );
  } else {
    return <p className="title-effect">Loading...</p>;
  }
}

export default MoreInfo;
